import { fmtINR } from "@/lib/api";

/**
 * Renders a product's price the right way for the viewer's role:
 *  - dealer / sales-with-dealer-selected: dealer price (large) + MRP (small)
 *  - sales, no dealer chosen yet: MRP (small) + the price group(s) their assigned
 *    dealers belong to (just MDD if all their dealers are MDD, both if they cover
 *    MDD and Sathya, etc.) — never groups outside their own scope
 *  - manager / admin / accounts, browsing (no dealer committed): MRP (small) +
 *    every price group's price as its own line, so tiers can be compared at a glance
 *  - anyone with a dealer actually selected (building a real order): same as
 *    dealer role — one resolved number, since cart math and the order itself
 *    need a single concrete price at that point
 */
export default function PriceBlock({ product, compact = false }) {
  if (!product) return null;

  const hasGroupPrices = Array.isArray(product.group_prices) && product.group_prices.length > 0;

  if (hasGroupPrices) {
    return (
      <div className="w-full text-right">
        <div className="space-y-0.5 w-full">
          {product.group_prices.map((gp) => (
            <div key={gp.group_name} className="flex items-center justify-end gap-2 text-xs">
              <span className="text-[11px] text-slate-500 font-medium whitespace-nowrap">{gp.group_name}:</span>
              <span className="font-semibold text-slate-900 whitespace-nowrap">{fmtINR(gp.price)}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (product.dealer_price === null || product.dealer_price === undefined) {
    return (
      <div className="w-full text-right">
        <div className="text-xs text-slate-400 italic">Price on request</div>
      </div>
    );
  }

  return (
    <div className="w-full text-right">
      <div className="text-[10px] text-slate-500 uppercase tracking-wide">Your Price excl. GST</div>
      <div className="text-base font-semibold text-slate-900">{fmtINR(product.dealer_price)}</div>
    </div>
  );
}
